import React from 'react';
import { formatDate, iconSportCssClass } from '../../data/utils';
import ScoreAndTime from './ScoreAndTime';

function EventInfo(props) {
    const event = props.event;
    return (
        <div className="d-flex align-items-center">
            {
                !props.isPsv && <span className={`sport-icon sport-img ${iconSportCssClass(event.sportRef, event.sportIcon)}`}></span>
            }
            
            <div className="d-flex flex-column justify-content-center event-info">
                <span className="text-small bold grey">{formatDate(event.timestamp).formatted}</span>
                <div className="d-flex align-items-center bold margine-su-giu desc-event-checkbet">
                    {event.desc}
	                {event.score?.length > 0 &&
                        <span>{event.score.replace(':', ' - ')}</span>
	                }
                    {props.isSystem && !event.var &&
                        <span className="ml-auto mr-2 bold">F</span>
                    }
                </div> 
                <span className="text-small bold grey">{event.tournamentDesc}</span>
                <ScoreAndTime {...event} />
            </div>
        </div>
    );
}

export default EventInfo;